import lottie from 'lottie-web';
import $ from 'jquery';
import anime from 'animejs';
import json from './active.json';
import {mouseMove, click} from '../../listeners.js';

import products from '../../products/active.json';

class Active {
  constructor() {
    this.anim = '';
  }

  load() {
    var anim = lottie.loadAnimation({
      container: $('.active')[0],
      renderer: 'svg',
      loop: false,
      autoplay: false,
      direction: 1,
      animationData: json,
      assetsPath: 'src/images/animations/active/'
    });
    anim.addEventListener('enterFrame', (e) =>{
      if (e.currentTime == e.totalTime - 1) {
        document.addEventListener("mousemove", (e) => {
          var elements = ['ashorts', 'shirt', 'activetitle'];
          mouseMove('active', elements, e);
        });
      }
    });

    $('.active').on('click', (e) => {
      console.log("click");
      click(products);
    });

    this.anim = anim;
    return anim;
  };

  inAnimation(direction) {
    if (direction === 'left') {
      $('.ashorts, .shirt').show();

      setTimeout(function () {
        SVG.select('.ashorts').animate(250).dx('1500px');
        SVG.select('.shirt').animate(250).dx('1500px');
        $('.activetitle').css({ opacity: ''});
        anime({ targets: '.activetitle', opacity: 1, easing: 'linear', duration: 250 });
      }, 800);
    } else {
      this.anim.setDirection(1);
      this.anim.play();
    }
  }

  outAnimation(direction) {
    if (direction === 'left') {
      this.anim.setDirection(-1);
      this.anim.play();
    } else {
      SVG.select('.ashorts').animate(250).dx('-1500px').after(function() {
        $('.ashorts').hide();
      });
      SVG.select('.shirt').animate(250).dx('-1500px').after(function() {
        $('.shirt').hide();
      });
      anime({ targets: '.activetitle', opacity: 0, easing: 'linear', duration: 250 });
    }
  }
}

export default new Active();
